
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/conference/admin",
      function () {
        return require("private-next-pages/conference/admin/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/conference/admin"])
      });
    }
  